<footer class="footer">
    <div class="container">
        <span class="text-muted">All Rights Reserved Born2Learn</span>
    </div>

</footer>